// extracted by mini-css-extract-plugin
export default {"btnBox":"dSYjUv5qmQRUWV9vbTeJ"};